import { Icon } from "@cadmakers-ui/icons";
import React from "react";
import { Button } from "reactstrap";
import { fileService } from "../../../Feedback/Services";
import iconStyles from "../../Styles/Icons.module.scss";

type Props = {
  onClick: (files: File[]) => void;
  className?: string;
  color?: string;
  style?: React.CSSProperties | undefined;
};

export default class FileUploadButton extends React.Component<Props> {
  private fileInputRef: React.RefObject<HTMLInputElement>;

  static defaultProps = {
    color: "primary"
  };

  constructor(props: Props) {
    super(props);

    this.fileInputRef = React.createRef();
  }

  onUploadClick = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.currentTarget.files) {
      this.props.onClick(fileService.fileListToFileArray(event.currentTarget.files));
    }
  };

  render() {
    return (
      <Button
        className={this.props.className}
        color={this.props.color}
        style={this.props.style}
        onClick={this.onUploadClick}
      >
        <input type="file" onChange={this.onInputChange} ref={this.fileInputRef} hidden multiple />
        <span style={{ marginRight: ".35rem" }}>
          <Icon
            appName="GeneralLayout"
            assetName="GENERAL_L_Upload"
            className={iconStyles.smallIcon}
          />
        </span>
        {this.props.children}
      </Button>
    );
  }
}
